const constants = {
  API: {
    getMoods: "/moods",
    getPlans: "/plans",
    getUsers: "/users",
    getMessages: "/messages",
    getCouples: "/couples",
    getSubscriptions: "/subscriptions",
    getTransactions: "/transactions",
    getAddon: "/addons",
    cronJob: "/cronjobs",
    upload: "/upload",
    bulkUpload: "/custom/bulkupload",
    contactUs: "/contact-uses",
    scheduledMessages: "/scheduled-messages",
    getScheduledMessages: "/scheduled-messages/custom/get-messages",
    // Dashboard specific endpoints
    dashboardStats: "/dashboard/stats",
    userGrowth: "/dashboard/user-growth",
    messageEngagement: "/dashboard/message-engagement",
    revenueAnalytics: "/dashboard/revenue",
    subscriptionBreakdown: "/dashboard/subscription-breakdown",
    popularMessages: "/dashboard/popular-messages",
    activityFeed: "/dashboard/activity-feed",
  },
};
export default constants;
